// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"ShippingMethodsList_contentComponent__1GTZv","tableContainer":"ShippingMethodsList_tableContainer__2lmjk"};